import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailClientReviewComponent } from './email-client-review.component';
import { FormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PopoverModule } from 'ngx-bootstrap';

@NgModule({
  declarations: [EmailClientReviewComponent],
  imports: [CommonModule, FormsModule, NgxDatatableModule, PopoverModule],
  exports: [EmailClientReviewComponent],
  entryComponents: [EmailClientReviewComponent],
})
export class EmailClientReviewModule {}
